import React, { createContext, useContext, useState } from "react";
import { CloserLoaderComponent } from "@fidget/common/components/loader/closerLoader";
import { LoadingState } from "./types";
import styles from "./withPreloading.css";

const PreloadingContext = createContext<PreloadingProps | undefined>(undefined);

export const usePreloader = (): PreloadingProps => {
  const context = useContext(PreloadingContext);

  if (context === undefined) {
    throw new Error("usePreloader must be used in withPreloading");
  }

  return context as PreloadingProps;
};
interface PreloadingProps {
  setLoadingState(state: LoadingState): void;
}

export const withPreloading =
  <P extends object>(Component: React.ComponentType<P>) =>
  (props: P) => {
    const [loadingState, setLoadingState] = useState<LoadingState>(LoadingState.Loading);

    const renderState = (): JSX.Element => {
      switch (loadingState) {
        case LoadingState.Loading:
          return <CloserLoaderComponent />;
        default:
          return <></>;
      }
    };

    if (loadingState === LoadingState.Loaded) {
      return (
        <PreloadingContext.Provider value={{ setLoadingState }}>
          <Component {...props} />
        </PreloadingContext.Provider>
      );
    }

    return (
      <>
        {renderState()}
        <div className={styles["display-none"]}>
          <PreloadingContext.Provider value={{ setLoadingState }}>
            <Component {...props} />
          </PreloadingContext.Provider>
        </div>
      </>
    );
  };
